import { Radio, RadioChangeEvent } from 'antd';
import parser from 'html-react-parser';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Apis from '../../../../../api';
import useIsTeamMember from '../../../../../hooks/useIsTeamMember';
import { HEADERMENU_PATH } from '../../../../../routes/RoutesURL';
import { RootState } from '../../../../../store/rootReducer';
import BackDrop from '../../../../common/BackDrop';
import HSButton from '../../../../common/Button';
import LoginActions from '../../../../login/redux/actions';
import { AIReview, Investorstatus } from '../../../../login/redux/types';
import { InvestorStatus } from '../../../../login/utils/Status';
import MessageActions from '../../../../message/redux/actions';
import { AIQualificationStatus } from '../../Constant';
import { ONBOARDING_PATH } from '../../Onbording';
import OnboardingHeading from '../OnboardingHeading';
import OnboardingRightContainer from '../common/Container';
import MyInfoModal from '../kyc/Modal/MyinfoModal';
import AIDocSection from './Doc';
import TypeChangeModal from './modal/TypeChange';

type Props = {
    isSetting?: boolean;
};

const AccreditedInvestor: React.FC<Props> = ({ isSetting }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const isTeamMember: boolean = useIsTeamMember();

    const [aiStatus, setAIStatus] = useState<string | undefined>(undefined);
    const [loading, setLoading] = useState(false);
    const [validate, setValidate] = useState(false);
    const [submitLoader, setSubmitLoader] = useState(false);

    const InvestorType = useSelector((state: RootState) => state.user.investor?.investorType);
    const kyc = useSelector((state: RootState) => state.user.investor?.kyc);
    const investorStatus = useSelector((state: RootState) => state.user.investor?.status);
    const investorUUID = useSelector((state: RootState) => state.user.uuid);
    const activeQualificationStatus = useSelector(
        (state: RootState) => state.user.investor?.accreditation?.activeQualificationStatus,
    );
    const AIDocList = useSelector((state: RootState) => state.user.investor?.accreditation?.documents);
    const accreditationReview = useSelector((state: RootState) => state.user.investor?.accreditation?.reviews);
    useEffect(() => {
        if (activeQualificationStatus) {
            setAIStatus(activeQualificationStatus);
        }
    }, [activeQualificationStatus]);

    const onChangeStatus = (status: string) => {
        if (investorUUID) {
            setLoading(true);
            Apis.updateAccreditation(investorUUID, {
                qualificationStatus: status,
                investorType: InvestorType,
            })
                .then(({ data }) => {
                    dispatch(LoginActions.updateInvestorInfo(data));
                })
                .catch((err) => {
                    dispatch(MessageActions.showMessage({ text: String(err), error: true }));
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    };

    const isValidate = () => {
        if (!aiStatus) {
            return false;
        }
        let doc: {
            url: string;
            uuid: string;
            title?: string | undefined;
            type?: string | undefined;
            isDeleted: boolean;
        }[] = [];
        const AIData = AIQualificationStatus.find((ai) => ai.type === InvestorType);
        let constDoc: {
            tooltip?: string | undefined;
            title: string;
            type: string;
            mandatory?: boolean;
        }[] = [];
        if (AIData) {
            const docs = AIData.doc.find((d) => d.status === aiStatus)?.list;
            constDoc = docs || [];
        }
        if (AIDocList && AIDocList.length > 0 && aiStatus) {
            doc = AIDocList || [];
        }
        if (doc.length === 0) {
            return false;
        } else {
            let flag = 1;
            let mandatory = 1;
            constDoc.forEach((d) => {
                // if (doc.filter((d1) => d1.type === d.type && !d1.isDeleted).length === 0) {
                //     flag = 1;
                //     console.log(flag);
                // }
                if (!d.mandatory) {
                    const isOneFileFound = doc.find((item) => item.type === d.type && item.isDeleted === false);
                    if (isOneFileFound) {
                        flag = 0;
                    }
                }
                // const findMandatoryFile=doc.find((item)=>item.)

                if (d.mandatory) {
                    const mandatoryFile = doc.find((item) => item.type === d.type && item.isDeleted === false);
                    if (!mandatoryFile) {
                        mandatory = 0;
                    }
                }
            });
            if (mandatory === 0) {
                return false;
            }
            if (flag === 1) {
                return false;
            }
        }

        return true;
    };
    const navigateToKYC = () => {
        if (InvestorType && !isSetting) {
            let selectedType = 'Manual';
            if (InvestorType === 'Individual Accredited') {
                if (!kyc || Object.keys(kyc).length === 0) {
                    selectedType = 'Option';
                }
            }
            navigate(`${HEADERMENU_PATH.onboarding}/${ONBOARDING_PATH.KYC}`, { state: { selectedType } });
        }
    };

    const onClickNext = () => {
        if (isTeamMember) {
            navigateToKYC();
            return;
        }
        setValidate(true);
        if (!isValidate()) {
            return;
        }

        setValidate(false);
        if (investorUUID) {
            setSubmitLoader(true);
            Apis.AISubmit(investorUUID, {
                action: investorStatus?.accreditation === InvestorStatus.PendingAIResubmission ? 'Resubmit' : 'Submit',
            })
                .then(({ data }) => {
                    dispatch(LoginActions.updateInvestorInfo(data));
                    if (!isSetting) {
                        navigateToKYC();
                    }
                    dispatch(MessageActions.showMessage({ text: String('Update Successfully'), error: false }));
                })
                .catch((err) => {
                    dispatch(MessageActions.showMessage({ text: String(err), error: true }));
                })
                .finally(() => {
                    setSubmitLoader(false);
                });
        }
    };

    const onClickSkipKYC = () => {
        let selectedType = 'Manual';
        if (InvestorType === 'Individual Accredited') {
            if (!kyc || Object.keys(kyc).length === 0) {
                selectedType = 'Option';
            }
        }
        navigate(`${HEADERMENU_PATH.onboarding}/${ONBOARDING_PATH.KYC}`, { state: { selectedType } });
    };
    const accreditationReviewInfo = useMemo(() => {
        const latestReview = (accreditationReview?.length && accreditationReview[accreditationReview.length - 1]) || {};
        const { comment } = latestReview as AIReview;
        const { accreditation } = investorStatus as Investorstatus;
        if (accreditation && accreditation.toLowerCase() === InvestorStatus.PendingAIAdditionalDetails.toLowerCase()) {
            return (
                <div className="bg-white mb-4 WorkSans px-6 py-4 border border-[#27AE60]">
                    <div className="text-[#0F2240] WorkSans-Bold">
                        Please review the following Accreditation Review Feedback and re-submit or add necessary
                        documents{' '}
                    </div>
                    <div className="font-bold !text-red-400 feedback_color">{parser(comment || '')}</div>
                </div>
            );
        }

        return null;
    }, [accreditationReview, investorStatus]);

    const isShowSubmitBtn = useMemo(() => {
        const accreditationStatus = investorStatus?.accreditation;
        return (
            accreditationStatus === InvestorStatus.PendingAISubmission ||
            accreditationStatus === InvestorStatus.PendingAIAdditionalDetails ||
            accreditationStatus === InvestorStatus.PendingAIResubmission
        );
    }, [investorStatus]);

    return (
        <OnboardingRightContainer>
            {accreditationReviewInfo}

            <OnboardingHeading
                title={'Qualification of Accredited Investor (AI) Status'}
                infoText={'AccreditedInvestor'}
            />
            <div className="bg-white p-3 my-4">
                <div className="border border-[#B1C1D4] px-4 py-3 flex justify-between items-center">
                    <p className="WorkSans text-[#20222B] text-sm">{InvestorType}</p>
                    {!isSetting && !isTeamMember && <TypeChangeModal />}
                </div>
                <p className="text-[#20222B] WorkSans-Semibold mt-4">
                    Select the statement appropriate to your Accredited Investor (AI) qualification status:
                </p>
                {/* <HSDropdown
                    value={aiStatus}
                    options={
                        (AIQualificationStatus.find((a) => a.type === InvestorType)?.list || []).map((s) => {
                            return { label: s, value: s };
                        }) || []
                    }
                    onChange={(data) => {
                        setAIStatus(data.value ? String(data.value) : undefined);
                        if (data.value) {
                            onChangeStatus(String(data.value));
                        }
                    }}
                    disabled={investorStatus?.accreditation === InvestorStatus.AIApproved}
                    name="aiStatus"
                    label=""
                /> */}
                <Radio.Group
                    className="radio_custome py-2 flex flex-col"
                    disabled={!isShowSubmitBtn}
                    onChange={(e: RadioChangeEvent) => {
                        if (!isTeamMember) {
                            setAIStatus(e.target.value ? String(e.target.value) : undefined);
                            if (e.target.value) {
                                onChangeStatus(e.target.value);
                            }
                        }
                    }}
                    value={aiStatus}
                >
                    {(AIQualificationStatus.find((a) => a.type === InvestorType)?.list || []).map((s) => {
                        return (
                            <Radio value={s} key={s} className="py-1">
                                {s}
                            </Radio>
                        );
                    })}
                </Radio.Group>
            </div>

            {aiStatus === 'Total income of at least S$300,000 (or equivalent) for the last 12 months' && (
                <div className="pt-1">
                    <p className="WorkSans-Semibold text-[#20222B] text-sm mb-4">
                        To allow our compliance team to validate your AI status, please use one of the means below:
                    </p>
                    <MyInfoModal isAI />

                    <div className="flex justify-between items-center pt-6 pb-3">
                        <div className="h-0.5 w-5/12 bg-[#B1C1D4]" />
                        <p className="text-[#B1C1D4]">OR</p>
                        <div className="h-0.5 w-5/12 bg-[#B1C1D4]" />
                    </div>

                    <p className="text-[#20222B]">Provide either one of the documents</p>
                </div>
            )}

            {InvestorType && aiStatus && (
                <AIDocSection
                    investorType={InvestorType}
                    selectedStatus={aiStatus}
                    validate={validate}
                    setValidate={setValidate}
                    disabled={!isShowSubmitBtn}
                />
            )}
            <p className="text-[#666666] text-xs mt-4 !font-[Lato]">
                By clicking "Next" you confirm having provided all required documents for our compliance officer to
                review your qualification of Accredited Investor (AI) status. If not you may resume your account
                creation at a later stage, contact us at{' '}
                <span className="text-[#142C53] underline WorkSans-Semibold">sales@heli-cap.com</span>, or skip AI
                verification to view past deals.
            </p>
            <div className="flex justify-center items-center my-6 w-full mb-2 flex-col">
                {isShowSubmitBtn && (
                    <HSButton
                        loading={submitLoader}
                        title={
                            isTeamMember
                                ? 'Next'
                                : investorStatus?.accreditation === InvestorStatus.PendingAIResubmission
                                ? 'Resubmit Accreditation'
                                : 'Submit Accreditation'
                        }
                        onClick={onClickNext}
                        // type="primary"
                        type="primary"
                        className={isTeamMember ? 'hidden' : ''}
                    />
                )}
                {!isSetting && (
                    <HSButton
                        type="link"
                        title={'Skip to KYC'}
                        onClick={onClickSkipKYC}
                        className="mt-4 underline color-1B3E8C hover:underline skip relative -top-3"
                    />
                )}
            </div>
            {loading && <BackDrop />}
        </OnboardingRightContainer>
    );
};

export default AccreditedInvestor;
